export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '035bc4d', dateTime: 1765478673017 };